import { WSElement, WSLabel } from "@wingspanhq/fe-component-library";
import { MethodType } from "../ManageMethods/types";
import { useMethodLabelProps } from "./useMethodLabelProps";

export type LabelMethodProps = {
  type: MethodType;
  id: string;
  showBalance?: boolean;
};

export const LabelMethod: React.FC<LabelMethodProps> = props => {
  const { isLoading, label } = useMethodLabelProps(props.id, props.type, {
    showBalance: props.showBalance
  });

  return (
    <WSElement shimmer={isLoading}>
      <WSLabel {...label} />
    </WSElement>
  );
};
